<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronLeft_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m6.274 12.063 4.675 4.52a.957.957 0 0 0 1.322 0 .882.882 0 0 0 0-1.278l-4.014-3.88 4.014-3.882a.882.882 0 0 0 0-1.278.957.957 0 0 0-1.322 0l-4.675 4.52a.882.882 0 0 0 0 1.278Zm5.454.151 4.676 4.52a.957.957 0 0 0 1.322 0 .882.882 0 0 0 0-1.278l-4.015-3.88 4.015-3.882a.882.882 0 0 0 0-1.278.957.957 0 0 0-1.322 0l-4.676 4.52a.882.882 0 0 0 0 1.278Z"
        clip-rule="evenodd"
    />
</svg>
